import React from "react";
import { TouchableOpacity, Text, View, Image } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import NoDataFound from "../NoDataFound";
import { AppImages } from "../../utility/AppImages";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import ImageComponent from "../ImageComponent";
import Avatar from "../choose-avatar-components/Avatar";
import SvgImage from "../choose-avatar-components/SvgImage";

type PlayersViewComponentProps = {
  styles?: any;
  participants: Array<{
    firstName: string;
    userID: string;
    profilePicture?: string;
  }>;
};

const PlayersViewComponent: React.FC<PlayersViewComponentProps> = ({
  styles,
  participants,
}) => {
  const navigation = useNavigation();

  const handleParticipantPress = (userID: string) => {
    navigateToScreen(navigation, AppScreens.UserProfile, {
      userId: userID,
    });
  };

  return (
    <View style={styles.playersView}>
      {participants && (
        <>
          <View>
            <TouchableOpacity
              onPress={() => handleParticipantPress(participants[0].userID)}
              style={styles.playerView}
            >
              <View
                style={[
                  styles.playerImg,
                  {
                    resizeMode: "contain",
                  },
                ]}
              >
                <Avatar
                  src={participants[0]?.profilePicture}
                  variant="fullForSignUp"
                  style={styles.playerImg}
                />
              </View>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_8,
                  { alignSelf: "center" },
                ]}
              >
                {participants[0]?.userID}
              </Text>
              {participants[0]?.userID && (
                <View
                  style={{
                    height: 1,
                    backgroundColor: AppColors.black,
                    width: 51,
                    justifyContent: "center",
                    alignSelf: "center",
                    marginBottom: 10,
                  }}
                />
              )}
            </TouchableOpacity>
          </View>
          <View style={{ marginVertical: 10 }}>
            <SvgImage
              src={AppImages.icVsLogo}
              variant="vsImage"
              item={styles.vsImage}
            />
          </View>
          <View>
            <TouchableOpacity
              onPress={() => handleParticipantPress(participants[1].userID)}
              style={styles.playerView}
            >
              <View
                style={[
                  styles.playerImg,
                  {
                    resizeMode: "contain",
                  },
                ]}
              >
                <Avatar
                  src={participants[1]?.profilePicture}
                  variant="fullForSignUp"
                  style={styles.playerImg}
                />
              </View>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_8,
                  { alignSelf: "center" },
                ]}
              >
                {participants[1]?.userID}
              </Text>
              {participants[1]?.userID && (
                <View
                  style={{
                    height: 1,
                    backgroundColor: AppColors.black,
                    width: 51,
                    justifyContent: "center",
                    alignSelf: "center",
                    marginBottom: 10,
                  }}
                />
              )}
            </TouchableOpacity>
          </View>
        </>
      )}
    </View>
  );
};

export default PlayersViewComponent;
